import { Box, Divider, Paper } from "@material-ui/core"
import CheckCircle from "@material-ui/icons/CheckCircle"
import Info from "@material-ui/icons/Info"
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked"
import { useMemo } from "react"
import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"
import { Body1, SubTitle1 } from "../../atoms"

import "./metadata-index-form-preview.styles.scss"

export interface IMetadataIndexFormPreviewProps {
  chapter?: string
  topicChapter?: string
  region?: string
  chapterTheme?: string
  theme?: string
  showUnderChapter: boolean
  showUnderRegion: boolean
}

export function MetadataIndexFormPreview(props: IMetadataIndexFormPreviewProps): ReactElement {
  const { chapter, topicChapter, region, chapterTheme, theme, showUnderChapter, showUnderRegion } = props

  const { t } = useTranslation("contentManager")

  const chapterSelectionsValid: boolean = useMemo<boolean>(() => {
    if (chapter === topicChapter) return false
    return true
  }, [chapter, topicChapter])

  return chapter ? (
    <Paper square className="metadata-index-form-preview">
      <Box className="info">
        <Info className={`info-icon ${!chapterSelectionsValid && "error"}`} />
        <Box>
          <Body1>{t("metadata.formFields.preview.showIndex")}</Body1>
          <SubTitle1>
            <b>{t("metadata.formFields.preview.noSaveWithoutCheck")}</b>
          </SubTitle1>
          {!chapterSelectionsValid && (
            <SubTitle1 className="error-text">{t("metadata.formFields.preview.differentTopicChapter")}</SubTitle1>
          )}
        </Box>
      </Box>
      <Divider />
      <MetadataIndexFormPreviewItem
        label={t("metadata.formFields.preview.chapter", { chapter })}
        checked={showUnderChapter && chapterSelectionsValid}
      />
      {chapterTheme && (
        <MetadataIndexFormPreviewItem
          className="indent-1"
          label={t("metadata.formFields.preview.chapterTheme", {
            chapterTheme
          })}
          checked={true}
        />
      )}
      {region && (
        <MetadataIndexFormPreviewItem
          className="indent-1"
          label={t("metadata.formFields.preview.region", {
            region
          })}
          checked={showUnderRegion}
        />
      )}
      {theme && (
        <MetadataIndexFormPreviewItem
          className="indent-2"
          label={t("metadata.formFields.preview.theme", {
            theme
          })}
          checked={true}
        />
      )}
      {topicChapter && (
        <MetadataIndexFormPreviewItem
          label={t("metadata.formFields.preview.topicChapter", {
            topicChapter
          })}
          checked={chapterSelectionsValid}
        />
      )}
    </Paper>
  ) : (
    <></>
  )
}

function MetadataIndexFormPreviewItem({
  label,
  checked,
  className
}: {
  label: string
  checked: boolean
  className?: string
}): ReactElement {
  return (
    <Box
      className={`
                metadata-index-form-preview-item 
                ${className || ""} 
                ${checked ? "checked" : ""}
            `}
    >
      {checked && <CheckCircle className="check" />}
      {!checked && <RadioButtonUnchecked className="no-check" />}
      <Body1>{label}</Body1>
    </Box>
  )
}
